import { render, staticRenderFns } from "./AuthSidebar.vue?vue&type=template&id=205019df"
import script from "./AuthSidebar.vue?vue&type=script&lang=js"
export * from "./AuthSidebar.vue?vue&type=script&lang=js"
import style0 from "./AuthSidebar.vue?vue&type=style&index=0&id=205019df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports